export const AutoShippingType = {
  handleAddProduct: "[autoshipping] handleAddProduct",
  handleRemoveProduct: "[autoshipping] handleRemoveProduct",
  handleSelectedAddress: "[autoshipping] handleSelectedAddress",
  autoshippingCreated: "[autoshipping] autoshippingCreated",
  error: "[autoshipping] error",
  clear: "[autoshipping] clear",
  setData: "[autoshipping] setData",
};
